'use client';

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import { Tooltip } from 'design-system/client';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import itz from './itz.svg';
import paypal from './paypal.svg';
import sslLogo from './ssl_logo.png';
import styles from './trust_logos.module.css';
import { SSLLogoProps } from './types';
import { useActionFormValues } from '@/form/ActionForm';
function PaymentMethodLogo() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payment_method"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [paymentMethod] = useActionFormValues(t0);
  let logo = null;
  let alt = "";
  if (paymentMethod === PaymentMethods.Paypal) {
    logo = paypal as string;
    alt = "PayPal Logo";
  }
  let t1;
  if ($[1] !== alt || $[2] !== logo) {
    t1 = logo && <Image src={logo} className={styles.trustLogo} alt={alt} width={135} height={36} />;
    $[1] = alt;
    $[2] = logo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function SSLLogo(t0) {
  const $ = _c(8);
  const {
    className
  } = t0;
  const t = useTranslations("nextjs.donate.trust_logos");
  let t1;
  if ($[0] !== t) {
    t1 = t("ssl_tooltip");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "auto"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== className) {
    t3 = <Image src={sslLogo} className={className} alt="SSL Logo" style={t2} />;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Tooltip content={t1} id="tooltip-for-ssl-logo">{t3}</Tooltip>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default function TrustLogos() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.trustLogos}><Image src={itz} className={styles.trustLogo} alt="Initiative Transparente Zivilgesellschaft Logo" /><SSLLogo className={styles.trustLogo} /><PaymentMethodLogo /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}